module.exports = __webpack_public_path__ + "static/media/logo.a6463b26.svg";